export default __webpack_public_path__ + "static/media/mn.43af9758.svg";